import { Form, Formik } from 'formik'
import moment from 'moment'
import { giftSubscriptionSchema } from 'src/common/validations'

import { useGiftSubscription } from 'src/hooks'
import { EAccountSubscriptionPlans, ISubscriptionGiftForm } from 'src/types'

import { GiftForm } from './form.component'

const initialValues: ISubscriptionGiftForm = {
  subscriptionPlan: EAccountSubscriptionPlans.plus,
  dueDate: moment(new Date()),
}

interface IProps {
  accountId: string
  handleClose: () => void
}

export const FormWrapper = ({ accountId, handleClose }: IProps) => {
  const { mutateAsync: giftSubscription } = useGiftSubscription()

  const handleSubmit = async (values: ISubscriptionGiftForm) => {
    const resp = await giftSubscription({
      accountId,
      subscriptionPlan: values.subscriptionPlan,
      dueDate: values.dueDate.toDate(),
    })
    if (!resp) return
    handleClose()
  }

  return (
    <Formik
      validationSchema={giftSubscriptionSchema}
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      <Form>
        <GiftForm />
      </Form>
    </Formik>
  )
}
